import api from '@/api';
import AffiliateRequest from '@/model/affiliate/AffiliateRequest';
import AffiliateSearchRequest from '@/model/affiliate/AffiliateSearchRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base().get('/affiliate/data')
        .then(response => commit('updateData', response.data.data));
    },
    getAllAffiliates(actions, { filter, pagination, sort }) {
      return api.base().post('/affiliate/get/all', AffiliateSearchRequest({ ...(filter || {}), pagination, sort, }))
        .then(response => ({ data: response.data.data, pagination: { page: response.data.metadata.page, total: response.data.metadata.total }, sort: response.data.metadata.sort }));
    },
    getAffiliateById({ commit }, id) {
      return api.base().get('/affiliate/id/' + id)
        .then(response => response.data.data);
    },
    getAffiliateByClientId({ commit }, id) {
      return api.base().get('/affiliate/clientId/' + id)
        .then(response => response.data.data);
    },
    getAffiliateTokens({ commit }, id) {
      return api.base().get('/affiliate/token/affiliate/' + id)
        .then(response => response.data.data);
    },
    createAffiliateToken(action, token){
      return api.base().post('/affiliate/token/create', token)
        .then(response => response.data.data);
    },
    updateAffiliateToken(action, token){
      return api.base().post('/affiliate/token/update/'+token.id, token)
        .then(response => response.data.data);
    },
    updateAffiliate({ commit }, { affiliate, id }) {
      return api.base()
        .post('/affiliate/update/' + id, AffiliateRequest(affiliate))
        .then(response => response.data.data);
    },

    createAffiliate({ commit }, { affiliate }) {
      return api.base()
        .post('/affiliate/add', AffiliateRequest(affiliate))
        .then(response => response.data.data);
    },

    deleteCpa({ commit }, {id,cpaId}) {
      return api.base()
        .post('/affiliate/delete/cpa/' + id + '/' + cpaId, )
        .then(response => response.data.data);
    },

    // Soft-delete (backend just flags deleted=true and hides it from the table).
    deleteAffiliate({ commit }, { id }) {
      return api.base()
        .post('/affiliate/delete', null, { params: { id } })
        .then(response => response.data.data);
    },

    createCpaAffiliate({ commit }, {id,cpa, confirm}) {
      return api.base()
        .post('/affiliate/add/cpa/' + id, cpa, { params: { confirm: confirm } })
        .then(response => response.data.data, error => {
          //Check status 406 and get message
          if (error.response != null && error.response.status === 406) {
            return Promise.reject({ message: error.response.data.message })
          }
          return Promise.reject({ error: error })
        })
    },
    editCpaAffiliate({ commit }, { id, cpaId, cpa, confirm }) {
      return api.base()
        .post('/affiliate/update/cpa/' + id + '/' + cpaId, cpa, { params: { confirm: confirm } })
        .then(response => response.data.data, error => {
          //Check status 406 and get message
          if (error.response != null && error.response.status === 406) {
            return Promise.reject({ message: error.response.data.message })
          }
          return Promise.reject({error: error })
        })
    },
    updateAffiliateTime({ commit }, { openingTime, id }) {
      return api.base()
        .post('/affiliate/update/time/' + id, {openingTime})
        .then(response => response.data.data);
    },
  }

};
